import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImportRegulatoryDocumentParagraphsMutationVariables = Types.Exact<{
  input: Types.ImportRegulatoryDocumentParagraphsInput;
}>;


export type ImportRegulatoryDocumentParagraphsMutation = { __typename?: 'Mutation', importRegulatoryDocumentParagraphs: { __typename?: 'ImportRegulatoryDocumentParagraphsPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string } | null } };


export const ImportRegulatoryDocumentParagraphsDocument = gql`
    mutation importRegulatoryDocumentParagraphs($input: ImportRegulatoryDocumentParagraphsInput!) {
  importRegulatoryDocumentParagraphs(input: $input) {
    regulatoryDocument {
      id
    }
  }
}
    `;
export type ImportRegulatoryDocumentParagraphsMutationFn = Apollo.MutationFunction<ImportRegulatoryDocumentParagraphsMutation, ImportRegulatoryDocumentParagraphsMutationVariables>;

/**
 * __useImportRegulatoryDocumentParagraphsMutation__
 *
 * To run a mutation, you first call `useImportRegulatoryDocumentParagraphsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRegulatoryDocumentParagraphsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRegulatoryDocumentParagraphsMutation, { data, loading, error }] = useImportRegulatoryDocumentParagraphsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRegulatoryDocumentParagraphsMutation(baseOptions?: Apollo.MutationHookOptions<ImportRegulatoryDocumentParagraphsMutation, ImportRegulatoryDocumentParagraphsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRegulatoryDocumentParagraphsMutation, ImportRegulatoryDocumentParagraphsMutationVariables>(ImportRegulatoryDocumentParagraphsDocument, options);
      }
export type ImportRegulatoryDocumentParagraphsMutationHookResult = ReturnType<typeof useImportRegulatoryDocumentParagraphsMutation>;
export type ImportRegulatoryDocumentParagraphsMutationResult = Apollo.MutationResult<ImportRegulatoryDocumentParagraphsMutation>;
export type ImportRegulatoryDocumentParagraphsMutationOptions = Apollo.BaseMutationOptions<ImportRegulatoryDocumentParagraphsMutation, ImportRegulatoryDocumentParagraphsMutationVariables>;